module.exports = __webpack_public_path__ + "img/flag-solid.252fb4d9.svg";